import React, { ReactNode } from 'react';

import { ENTITY_COLORIZATION, ENTITY_ICONS }              from '@src/constants';
import { ProjectService, ProjectTimelineDateFieldObject } from '@src/services/ProjectService';
import { CustomMilestoneIcon }                            from '@src/views/components/project/CustomMilestoneIcon';
import { MilestoneDateIcon }                              from '@src/views/components/project/MilestoneDateIcon';


type UseProjectMilestoneHookMethod = () => UseProjectMilestoneHook;

export type UseProjectMilestoneHook = {
    getTimelineFieldIcon: ( field: ProjectTimelineDateFieldObject ) => ReactNode
};

export const useProjectMilestone: UseProjectMilestoneHookMethod = () => {

    const getTimelineFieldIcon: UseProjectMilestoneHook['getTimelineFieldIcon'] = ( field ) => {

        let milestoneInfo     = ProjectService.getMilestoneInfoFromField( field.fieldId ),
            isSystemMilestone = ProjectService.timelineDataObjectIsSystemMilestone( field ),
            isCustomMilestone = ProjectService.timelineDataObjectIsCustomMilestone( field );

        let iconProp = {
            color: milestoneInfo ? milestoneInfo.COLOR : ENTITY_COLORIZATION.MILESTONES.SYSTEM,
            name:  isSystemMilestone ? ENTITY_ICONS.MILESTONES.ITEM : ENTITY_ICONS.MILESTONES.CUSTOM
        };

        const MilestoneIcon = isSystemMilestone ? MilestoneDateIcon : CustomMilestoneIcon;


        if( !isSystemMilestone && !isCustomMilestone ){
            return null
        }

        return (

            <MilestoneIcon
                key={ field.fieldId }
                label={ field.label }
                date={ field.value }
                desc={ field.description }
                icon={ iconProp as any }
            />

        )
    }


    return { getTimelineFieldIcon };
};
